import { isFunction } from '../functions';

export default class Videos {
  constructor($videos) {
    this.$videos = $videos;

    this.queue = [];
    this.videos = [];

    this.$videos.forEach( $video => this.bindVideo($video));
  }

  bindVideo($video) {
    if ($video.offsetParent === null) return;

    $video.dataset.loop = $video.loop;
    $video.dataset.visible = false;
    $video.dataset.loaded = false;

    let counter = this.videos.length;
    $video.dataset.index = counter;
    this.videos.push($video);

    $video.loop = false;
    $video.autoplay = false;

    $video.addEventListener('loadeddata', this.onLoadedDataVideo.bind(this));
  }

  onLoadedDataVideo(event) {
    var $video = event.target;
    console.log('video loaded', $video.currentSrc);

    if ($video.src.includes('blank.mp4') || $video.dataset.loaded === true) return;

    $video.dataset.loaded = true;

    $video.addEventListener('ended', this.onVideoEnded.bind(this));

    if (isFunction(IntersectionObserver)) {
      let options = { };
      let observer = new IntersectionObserver(this.onVideoObservation.bind(this), options);
      observer.observe($video);
      console.log('Observe video', $video.currentSrc);
    } else {
      // if intersection observer not available, do nothing
    }
  }

  pauseVideo($video) {
    if (this.playPromise !== undefined) {
      this.playPromise.then(function() {
        $video.pause();
      })
      .catch(function(error) {
        console.log(error);
      });
    }
  }

  queueVideo($video) {
    if (this.queue.indexOf($video.dataset.index) === -1) {
      this.queue.push($video.dataset.index);
      console.log('Video playback queued', $video.currentSrc, this.queue.length);
    }
  }

  unqueueVideo($video) {
    let queueIdx = this.queue.indexOf($video.dataset.index);
    if (queueIdx !== -1) {
      this.queue.splice(queueIdx, 1);
      console.log('Video unqueued : ', this.queue)
    }

    if (this.isVideoPlaying($video)) {
      this.pauseVideo($video);
    }
  }

  getVideoByIndex(index) {
    return this.videos[index];
  }

  isVideoPlaying($video) {
    var result = !$video.paused;
    console.log('Is video playing ? ', result, $video.currentSrc);
    return result;
  }

  resume() {
    // console.log('resume', this.queue);
    if (this.queue.length > 0) {
      var $next = this.getVideoByIndex(this.queue[0]);

      if (!this.isVideoPlaying($next)) {
        console.log('$next.play()');
        this.playPromise = $next.play();
        console.log('Video playback started', $next.currentSrc, this.queue.length);
      }
    }
  }

  stop() {
    // console.log('stop', this.queue);
    if (this.queue.length > 0) {
      var $current = this.getVideoByIndex(this.queue[0]);

      if (this.isVideoPlaying($current)) {
        this.pauseVideo($current);
      }
    }
  }

  onVideoEnded(event) {
    var $video = event.target;

    console.log('Video playback ended', $video.currentSrc);
    this.unqueueVideo($video);

    $video.currentTime = 0;
    if ($video.dataset.loop === 'true' && $video.dataset.visible === 'true') {
      this.queueVideo($video);
    }

    this.resume();
  }

  onVideoObservation(intersections) {
    const inters = intersections[0];
    var $video = inters.target;

    if (inters.isIntersecting) {
      console.log('Video in viewport', $video.currentSrc);
      $video.dataset.visible = true;

      this.queueVideo($video);
      this.resume()

    } else {
      console.log('Video not in viewport anymore', $video.currentSrc);
      $video.dataset.visible = false;

      console.log('Stop playing video in viewport', $video.currentSrc);
      this.unqueueVideo($video);

      this.resume();

    }
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/Videos.js